// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/common/types/v1/channel_ids.proto (package quanterix.common.types.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file quanterix/common/types/v1/channel_ids.proto.
 */
export const file_quanterix_common_types_v1_channel_ids: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @remarks
 * This type is equivalent to quanterix.protos.type.ChannelIDs
 *
 * @generated from enum quanterix.common.types.v1.ChannelIds
 */
export enum ChannelIds {
  /**
   * @generated from enum value: CHANNEL_IDS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Attune
   *
   * @generated from enum value: CHANNEL_IDS_FSC_A = 1;
   */
  FSC_A = 1,

  /**
   * @generated from enum value: CHANNEL_IDS_SSC_A = 2;
   */
  SSC_A = 2,

  /**
   * @generated from enum value: CHANNEL_IDS_RL1_A = 3;
   */
  RL1_A = 3,

  /**
   * @generated from enum value: CHANNEL_IDS_YL1_A = 4;
   */
  YL1_A = 4,

  /**
   * @generated from enum value: CHANNEL_IDS_BL1_A = 5;
   */
  BL1_A = 5,

  /**
   * @generated from enum value: CHANNEL_IDS_RL2_A = 6;
   */
  RL2_A = 6,

  /**
   * @generated from enum value: CHANNEL_IDS_RL3_A = 7;
   */
  RL3_A = 7,

  /**
   * @generated from enum value: CHANNEL_IDS_YL2_A = 8;
   */
  YL2_A = 8,

  /**
   * @generated from enum value: CHANNEL_IDS_YL3_A = 9;
   */
  YL3_A = 9,

  /**
   * @generated from enum value: CHANNEL_IDS_YL4_A = 10;
   */
  YL4_A = 10,

  /**
   * Emission
   *
   * @generated from enum value: CHANNEL_IDS_RED_SSC = 11;
   */
  RED_SSC = 11,

  /**
   * @generated from enum value: CHANNEL_IDS_GREEN_SSC = 12;
   */
  GREEN_SSC = 12,

  /**
   * @generated from enum value: CHANNEL_IDS_GREEN_B = 13;
   */
  GREEN_B = 13,

  /**
   * @generated from enum value: CHANNEL_IDS_GREEN_C = 14;
   */
  GREEN_C = 14,

  /**
   * @generated from enum value: CHANNEL_IDS_RED_C = 15;
   */
  RED_C = 15,

  /**
   * @generated from enum value: CHANNEL_IDS_RED_D = 16;
   */
  RED_D = 16,

  /**
   * @generated from enum value: CHANNEL_IDS_REGION = 17;
   */
  REGION = 17,

  /**
   * @generated from enum value: CHANNEL_IDS_REPORTER = 18;
   */
  REPORTER = 18,

  /**
   * @generated from enum value: CHANNEL_IDS_VIOL_B = 19;
   */
  VIOL_B = 19,

  /**
   * @generated from enum value: CHANNEL_IDS_RED_A = 20;
   */
  RED_A = 20,

  /**
   * @generated from enum value: CHANNEL_IDS_FORWARD_SCATTER = 21;
   */
  FORWARD_SCATTER = 21,

  /**
   * @generated from enum value: CHANNEL_IDS_VIOLET_SSC = 22;
   */
  VIOLET_SSC = 22,

  /**
   * @generated from enum value: CHANNEL_IDS_GREEN_D = 110;
   */
  GREEN_D = 110,

  /**
   * TTP
   *
   * @generated from enum value: CHANNEL_IDS_PE_A = 31;
   */
  PE_A = 31,

  /**
   * @generated from enum value: CHANNEL_IDS_APC_A = 32;
   */
  APC_A = 32,

  /**
   * @generated from enum value: CHANNEL_IDS_APC_A750_A = 33;
   */
  APC_A750_A = 33,

  /**
   * extended Attune
   *
   * @generated from enum value: CHANNEL_IDS_BL2_A = 41;
   */
  BL2_A = 41,

  /**
   * @generated from enum value: CHANNEL_IDS_BL3_A = 42;
   */
  BL3_A = 42,

  /**
   * Cytek
   *
   * @generated from enum value: CHANNEL_IDS_UV_A = 43;
   */
  UV_A = 43,

  /**
   * @generated from enum value: CHANNEL_IDS_UV2_A = 44;
   */
  UV2_A = 44,

  /**
   * @generated from enum value: CHANNEL_IDS_UV3_A = 45;
   */
  UV3_A = 45,

  /**
   * @generated from enum value: CHANNEL_IDS_UV4_A = 46;
   */
  UV4_A = 46,

  /**
   * @generated from enum value: CHANNEL_IDS_UV5_A = 47;
   */
  UV5_A = 47,

  /**
   * @generated from enum value: CHANNEL_IDS_UV6_A = 48;
   */
  UV6_A = 48,

  /**
   * @generated from enum value: CHANNEL_IDS_UV7_A = 49;
   */
  UV7_A = 49,

  /**
   * @generated from enum value: CHANNEL_IDS_UV8_A = 50;
   */
  UV8_A = 50,

  /**
   * @generated from enum value: CHANNEL_IDS_UV9_A = 51;
   */
  UV9_A = 51,

  /**
   * @generated from enum value: CHANNEL_IDS_UV10_A = 52;
   */
  UV10_A = 52,

  /**
   * @generated from enum value: CHANNEL_IDS_UV11_A = 53;
   */
  UV11_A = 53,

  /**
   * @generated from enum value: CHANNEL_IDS_UV12_A = 54;
   */
  UV12_A = 54,

  /**
   * @generated from enum value: CHANNEL_IDS_UV13_A = 55;
   */
  UV13_A = 55,

  /**
   * @generated from enum value: CHANNEL_IDS_UV14_A = 56;
   */
  UV14_A = 56,

  /**
   * @generated from enum value: CHANNEL_IDS_UV15_A = 57;
   */
  UV15_A = 57,

  /**
   * @generated from enum value: CHANNEL_IDS_UV16_A = 58;
   */
  UV16_A = 58,

  /**
   * @generated from enum value: CHANNEL_IDS_V1_A = 59;
   */
  V1_A = 59,

  /**
   * @generated from enum value: CHANNEL_IDS_V2_A = 60;
   */
  V2_A = 60,

  /**
   * @generated from enum value: CHANNEL_IDS_V3_A = 61;
   */
  V3_A = 61,

  /**
   * @generated from enum value: CHANNEL_IDS_V4_A = 62;
   */
  V4_A = 62,

  /**
   * @generated from enum value: CHANNEL_IDS_V5_A = 63;
   */
  V5_A = 63,

  /**
   * @generated from enum value: CHANNEL_IDS_V6_A = 64;
   */
  V6_A = 64,

  /**
   * @generated from enum value: CHANNEL_IDS_V7_A = 65;
   */
  V7_A = 65,

  /**
   * @generated from enum value: CHANNEL_IDS_V8_A = 66;
   */
  V8_A = 66,

  /**
   * @generated from enum value: CHANNEL_IDS_V9_A = 67;
   */
  V9_A = 67,

  /**
   * @generated from enum value: CHANNEL_IDS_V10_A = 68;
   */
  V10_A = 68,

  /**
   * @generated from enum value: CHANNEL_IDS_V11_A = 69;
   */
  V11_A = 69,

  /**
   * @generated from enum value: CHANNEL_IDS_V12_A = 70;
   */
  V12_A = 70,

  /**
   * @generated from enum value: CHANNEL_IDS_V13_A = 71;
   */
  V13_A = 71,

  /**
   * @generated from enum value: CHANNEL_IDS_V14_A = 72;
   */
  V14_A = 72,

  /**
   * @generated from enum value: CHANNEL_IDS_V15_A = 73;
   */
  V15_A = 73,

  /**
   * @generated from enum value: CHANNEL_IDS_V16_A = 74;
   */
  V16_A = 74,

  /**
   * @generated from enum value: CHANNEL_IDS_SSC_B_H = 75;
   */
  SSC_B_H = 75,

  /**
   * @generated from enum value: CHANNEL_IDS_SSC_B_A = 76;
   */
  SSC_B_A = 76,

  /**
   * @generated from enum value: CHANNEL_IDS_B1_A = 77;
   */
  B1_A = 77,

  /**
   * @generated from enum value: CHANNEL_IDS_B2_A = 78;
   */
  B2_A = 78,

  /**
   * @generated from enum value: CHANNEL_IDS_B3_A = 79;
   */
  B3_A = 79,

  /**
   * @generated from enum value: CHANNEL_IDS_B4_A = 80;
   */
  B4_A = 80,

  /**
   * @generated from enum value: CHANNEL_IDS_B5_A = 81;
   */
  B5_A = 81,

  /**
   * @generated from enum value: CHANNEL_IDS_B6_A = 82;
   */
  B6_A = 82,

  /**
   * @generated from enum value: CHANNEL_IDS_B7_A = 83;
   */
  B7_A = 83,

  /**
   * @generated from enum value: CHANNEL_IDS_B8_A = 84;
   */
  B8_A = 84,

  /**
   * @generated from enum value: CHANNEL_IDS_B9_A = 85;
   */
  B9_A = 85,

  /**
   * @generated from enum value: CHANNEL_IDS_B10_A = 86;
   */
  B10_A = 86,

  /**
   * @generated from enum value: CHANNEL_IDS_B11_A = 87;
   */
  B11_A = 87,

  /**
   * @generated from enum value: CHANNEL_IDS_B12_A = 88;
   */
  B12_A = 88,

  /**
   * @generated from enum value: CHANNEL_IDS_B13_A = 89;
   */
  B13_A = 89,

  /**
   * @generated from enum value: CHANNEL_IDS_B14_A = 90;
   */
  B14_A = 90,

  /**
   * @generated from enum value: CHANNEL_IDS_YG1_A = 91;
   */
  YG1_A = 91,

  /**
   * @generated from enum value: CHANNEL_IDS_YG2_A = 92;
   */
  YG2_A = 92,

  /**
   * @generated from enum value: CHANNEL_IDS_YG3_A = 93;
   */
  YG3_A = 93,

  /**
   * @generated from enum value: CHANNEL_IDS_YG4_A = 94;
   */
  YG4_A = 94,

  /**
   * @generated from enum value: CHANNEL_IDS_YG5_A = 95;
   */
  YG5_A = 95,

  /**
   * @generated from enum value: CHANNEL_IDS_YG6_A = 96;
   */
  YG6_A = 96,

  /**
   * @generated from enum value: CHANNEL_IDS_YG7_A = 97;
   */
  YG7_A = 97,

  /**
   * @generated from enum value: CHANNEL_IDS_YG8_A = 98;
   */
  YG8_A = 98,

  /**
   * @generated from enum value: CHANNEL_IDS_YG9_A = 99;
   */
  YG9_A = 99,

  /**
   * @generated from enum value: CHANNEL_IDS_YG10_A = 100;
   */
  YG10_A = 100,

  /**
   * @generated from enum value: CHANNEL_IDS_R1_A = 101;
   */
  R1_A = 101,

  /**
   * @generated from enum value: CHANNEL_IDS_R2_A = 102;
   */
  R2_A = 102,

  /**
   * @generated from enum value: CHANNEL_IDS_R3_A = 103;
   */
  R3_A = 103,

  /**
   * @generated from enum value: CHANNEL_IDS_R4_A = 104;
   */
  R4_A = 104,

  /**
   * @generated from enum value: CHANNEL_IDS_R5_A = 105;
   */
  R5_A = 105,

  /**
   * @generated from enum value: CHANNEL_IDS_R6_A = 106;
   */
  R6_A = 106,

  /**
   * @generated from enum value: CHANNEL_IDS_R7_A = 107;
   */
  R7_A = 107,

  /**
   * @generated from enum value: CHANNEL_IDS_R8_A = 108;
   */
  R8_A = 108,

  /**
   * @generated from enum value: CHANNEL_IDS_A405_OLS = 109;
   */
  A405_OLS = 109,
}

/**
 * Describes the enum quanterix.common.types.v1.ChannelIds.
 */
export const ChannelIdsSchema: GenEnum<ChannelIds> = /*@__PURE__*/
  enumDesc(file_quanterix_common_types_v1_channel_ids, 0);

